import {CSSProperties, ReactNode, Ref} from 'react';
import {type Props as ReactModalProps} from 'react-modal';

export enum EFlyoutDirections {
	RIGHT_TO_LEFT = 'RTL',
	LEFT_TO_RIGHT = 'LTR',
	BOTTOM_TO_TOP = 'BTT',
	HEIGHT_TOP_TO_BOTTOM = 'HTTB',
	LEFT_TO_RIGHT_TO_LEFT = 'LTRTL',
}

export interface IFlyoutProps {
	ref?: Ref<HTMLDivElement>;
	id: string;
	children: ReactNode | ReactNode[];
	direction?: EFlyoutDirections;
	onClose?: () => void;
	className?: string;
	showCloseButton?: boolean;
	closeClassName?: string;
	flyoutClassName?: string;
	contentClassName?: string;
	closeButtonText?: string;
	closeButtonDimension?: {
		width?: number;
		height?: number;
	};
	closeIconName?: string;
	onAfterOpen?: () => void;
	onAfterClose?: () => void;
	parentSelector?: ReactModalProps['parentSelector'];
	style?: {
		overlay?: CSSProperties;
		content?: CSSProperties;
	};
	softLock?: boolean;
	closeTimeoutMS?: number;
	restoreScrollPosition?: boolean;
	withNavigationDSK?: boolean;
	withNavigationMOB?: boolean;
}
